import _classCallCheck from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/workpath0/node_modules/@babel/runtime/regenerator";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import '../flags';
import { env } from '../environment';
import { getModelArtifactsInfoForJSON } from './io_utils';
import { IORouterRegistry } from './router_registry';
var DATABASE_NAME = 'tensorflowjs';
var DATABASE_VERSION = 1; // Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.

var MODEL_STORE_NAME = 'models_store'; // 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.

var INFO_STORE_NAME = 'model_info_store';
/**
 * Delete the entire database for tensorflow.js, including the models store.
 */

export function deleteDatabase() {
  return _deleteDatabase.apply(this, arguments);
}

function _deleteDatabase() {
  _deleteDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var idbFactory;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            idbFactory = getIndexedDBFactory();
            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              var deleteRequest = idbFactory.deleteDatabase(DATABASE_NAME);

              deleteRequest.onsuccess = function () {
                return resolve();
              };

              deleteRequest.onerror = function (error) {
                return reject(error);
              };
            }));

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteDatabase.apply(this, arguments);
}

function getIndexedDBFactory() {
  if (!env().getBool('IS_BROWSER')) {
    // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error('Failed to obtain IndexedDB factory because the current environment' + 'is not a web browser.');
  } // tslint:disable-next-line:no-any


  var theWindow = typeof window === 'undefined' ? self : window;
  var factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;

  if (factory == null) {
    throw new Error('The current browser does not appear to support IndexedDB.');
  }

  return factory;
}

function setUpDatabase(openRequest) {
  var db = openRequest.result;
  db.createObjectStore(MODEL_STORE_NAME, {
    keyPath: 'modelPath'
  });
  db.createObjectStore(INFO_STORE_NAME, {
    keyPath: 'modelPath'
  });
}
/**
 * IOHandler subclass: Browser IndexedDB.
 *
 * See the doc string of `browserIndexedDB` for more details.
 */


export var BrowserIndexedDB = /*#__PURE__*/function () {
  function BrowserIndexedDB(modelPath) {
    _classCallCheck(this, BrowserIndexedDB);

    this.indexedDB = getIndexedDBFactory();

    if (modelPath == null || !modelPath) {
      throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
    }

    this.modelPath = modelPath;
  }

  _createClass(BrowserIndexedDB, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(modelArtifacts) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(modelArtifacts.modelTopology instanceof ArrayBuffer)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('BrowserLocalStorage.save() does not support saving model topology ' + 'in binary formats yet.');

              case 2:
                return _context.abrupt("return", this.databaseAction(this.modelPath, modelArtifacts));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save(_x) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.databaseAction(this.modelPath));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */

  }, {
    key: "databaseAction",
    value: function databaseAction(modelPath, modelArtifacts) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var openRequest = _this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);

        openRequest.onupgradeneeded = function () {
          return setUpDatabase(openRequest);
        };

        openRequest.onsuccess = function () {
          var db = openRequest.result;

          if (modelArtifacts == null) {
            // Read model out from object store.
            var modelTx = db.transaction(MODEL_STORE_NAME, 'readonly');
            var modelStore = modelTx.objectStore(MODEL_STORE_NAME);
            var getRequest = modelStore.get(_this.modelPath);

            getRequest.onsuccess = function () {
              if (getRequest.result == null) {
                db.close();
                return reject(new Error("Cannot find model with path '".concat(_this.modelPath, "' ") + "in IndexedDB."));
              } else {
                resolve(getRequest.result.modelArtifacts);
              }
            };

            getRequest.onerror = function (error) {
              db.close();
              return reject(getRequest.error);
            };

            modelTx.oncomplete = function () {
              return db.close();
            };
          } else {
            // Put model into object store.
            var modelArtifactsInfo = getModelArtifactsInfoForJSON(modelArtifacts); // First, put ModelArtifactsInfo into info store.

            var infoTx = db.transaction(INFO_STORE_NAME, 'readwrite');
            var infoStore = infoTx.objectStore(INFO_STORE_NAME);
            var putInfoRequest = infoStore.put({
              modelPath: _this.modelPath,
              modelArtifactsInfo: modelArtifactsInfo
            });

            var _modelTx;

            putInfoRequest.onsuccess = function () {
              // Second, put model data into model store.
              _modelTx = db.transaction(MODEL_STORE_NAME, 'readwrite');

              var modelStore = _modelTx.objectStore(MODEL_STORE_NAME);

              var putModelRequest = modelStore.put({
                modelPath: _this.modelPath,
                modelArtifacts: modelArtifacts,
                modelArtifactsInfo: modelArtifactsInfo
              });

              putModelRequest.onsuccess = function () {
                return resolve({
                  modelArtifactsInfo: modelArtifactsInfo
                });
              };

              putModelRequest.onerror = function (error) {
                // If the put-model request fails, roll back the info entry as
                // well.
                infoStore = infoTx.objectStore(INFO_STORE_NAME);
                var deleteInfoRequest = infoStore.delete(_this.modelPath);

                deleteInfoRequest.onsuccess = function () {
                  db.close();
                  return reject(putModelRequest.error);
                };

                deleteInfoRequest.onerror = function (error) {
                  db.close();
                  return reject(putModelRequest.error);
                };
              };
            };

            putInfoRequest.onerror = function (error) {
              db.close();
              return reject(putInfoRequest.error);
            };

            infoTx.oncomplete = function () {
              if (_modelTx == null) {
                db.close();
              } else {
                _modelTx.oncomplete = function () {
                  return db.close();
                };
              }
            };
          }
        };

        openRequest.onerror = function (error) {
          return reject(openRequest.error);
        };
      });
    }
  }]);

  return BrowserIndexedDB;
}();
BrowserIndexedDB.URL_SCHEME = 'indexeddb://';
export var indexedDBRouter = function indexedDBRouter(url) {
  if (!env().getBool('IS_BROWSER')) {
    return null;
  } else {
    if (!Array.isArray(url) && url.startsWith(BrowserIndexedDB.URL_SCHEME)) {
      return browserIndexedDB(url.slice(BrowserIndexedDB.URL_SCHEME.length));
    } else {
      return null;
    }
  }
};
IORouterRegistry.registerSaveRouter(indexedDBRouter);
IORouterRegistry.registerLoadRouter(indexedDBRouter);
/**
 * Creates a browser IndexedDB IOHandler for saving and loading models.
 *
 * ```js
 * const model = tf.sequential();
 * model.add(
 *     tf.layers.dense({units: 1, inputShape: [100], activation: 'sigmoid'}));
 *
 * const saveResult = await model.save('indexeddb://MyModel'));
 * console.log(saveResult);
 * ```
 *
 * @param modelPath A unique identifier for the model to be saved. Must be a
 *   non-empty string.
 * @returns An instance of `BrowserIndexedDB` (sublcass of `IOHandler`),
 *   which can be used with, e.g., `tf.Model.save`.
 */

export function browserIndexedDB(modelPath) {
  return new BrowserIndexedDB(modelPath);
}

function maybeStripScheme(key) {
  return key.startsWith(BrowserIndexedDB.URL_SCHEME) ? key.slice(BrowserIndexedDB.URL_SCHEME.length) : key;
}

export var BrowserIndexedDBManager = /*#__PURE__*/function () {
  function BrowserIndexedDBManager() {
    _classCallCheck(this, BrowserIndexedDBManager);

    this.indexedDB = getIndexedDBFactory();
  }

  _createClass(BrowserIndexedDBManager, [{
    key: "listModels",
    value: function () {
      var _listModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var openRequest = _this2.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);

                  openRequest.onupgradeneeded = function () {
                    return setUpDatabase(openRequest);
                  };

                  openRequest.onsuccess = function () {
                    var db = openRequest.result;
                    var tx = db.transaction(INFO_STORE_NAME, 'readonly');
                    var store = tx.objectStore(INFO_STORE_NAME); // tslint:disable:max-line-length
                    // Need to cast `store` as `any` here because TypeScript's DOM
                    // library does not have the `getAll()` method even though the
                    // method is supported in the latest version of most mainstream
                    // browsers:
                    // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                    // tslint:enable:max-line-length
                    // tslint:disable-next-line:no-any

                    var getAllInfoRequest = store.getAll();

                    getAllInfoRequest.onsuccess = function () {
                      var out = {};

                      var _iterator = _createForOfIteratorHelper(getAllInfoRequest.result),
                          _step;

                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var item = _step.value;
                          out[item.modelPath] = item.modelArtifactsInfo;
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }

                      resolve(out);
                    };

                    getAllInfoRequest.onerror = function (error) {
                      db.close();
                      return reject(getAllInfoRequest.error);
                    };

                    tx.oncomplete = function () {
                      return db.close();
                    };
                  };

                  openRequest.onerror = function (error) {
                    return reject(openRequest.error);
                  };
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function listModels() {
        return _listModels.apply(this, arguments);
      }

      return listModels;
    }()
  }, {
    key: "removeModel",
    value: function () {
      var _removeModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                path = maybeStripScheme(path);
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  var openRequest = _this3.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);

                  openRequest.onupgradeneeded = function () {
                    return setUpDatabase(openRequest);
                  };

                  openRequest.onsuccess = function () {
                    var db = openRequest.result;
                    var infoTx = db.transaction(INFO_STORE_NAME, 'readwrite');
                    var infoStore = infoTx.objectStore(INFO_STORE_NAME);
                    var getInfoRequest = infoStore.get(path);
                    var modelTx;

                    getInfoRequest.onsuccess = function () {
                      if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error("Cannot find model with path '".concat(path, "' ") + "in IndexedDB."));
                      } else {
                        // First, delete the entry in the info store.
                        var deleteInfoRequest = infoStore.delete(path);

                        var deleteModelData = function deleteModelData() {
                          // Second, delete the entry in the model store.
                          modelTx = db.transaction(MODEL_STORE_NAME, 'readwrite');
                          var modelStore = modelTx.objectStore(MODEL_STORE_NAME);
                          var deleteModelRequest = modelStore.delete(path);

                          deleteModelRequest.onsuccess = function () {
                            return resolve(getInfoRequest.result.modelArtifactsInfo);
                          };

                          deleteModelRequest.onerror = function (error) {
                            return reject(getInfoRequest.error);
                          };
                        }; // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.


                        deleteInfoRequest.onsuccess = deleteModelData;

                        deleteInfoRequest.onerror = function (error) {
                          deleteModelData();
                          db.close();
                          return reject(getInfoRequest.error);
                        };
                      }
                    };

                    getInfoRequest.onerror = function (error) {
                      db.close();
                      return reject(getInfoRequest.error);
                    };

                    infoTx.oncomplete = function () {
                      if (modelTx == null) {
                        db.close();
                      } else {
                        modelTx.oncomplete = function () {
                          return db.close();
                        };
                      }
                    };
                  };

                  openRequest.onerror = function (error) {
                    return reject(openRequest.error);
                  };
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function removeModel(_x2) {
        return _removeModel.apply(this, arguments);
      }

      return removeModel;
    }()
  }]);

  return BrowserIndexedDBManager;
}();